import { RemoteGetProfessionalsDailyWorkload } from 'data/usecases';
import { GetProfessionalsDailyWorkloadUseCaseInterface } from 'domain/usecases';
import { makeApiUrlProfessionalsDailyWorkload } from 'main/factories/http/api-url-factory';
import { makeAxiosHttpClient } from 'main/factories/http/axios-http-client-factory';

export const makeGetProfessionalsDailyWorkload =
  (): GetProfessionalsDailyWorkloadUseCaseInterface =>
    new RemoteGetProfessionalsDailyWorkload(
      makeApiUrlProfessionalsDailyWorkload(),
      makeAxiosHttpClient(),
    );
